export default `/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([grow="1"]) {
  min-height: 0;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host([hide]) {
  display: none;
}

@container (width >= 320px) {
  :host([hide=xs]) {
    display: block;
  }
}
@container (width >= 767px) {
  :host([hide=sm]) {
    display: block;
  }
}
@container (width >= 927px) {
  :host([hide=md]) {
    display: block;
  }
}
@container (width >= 928px) {
  :host([hide=lg]) {
    display: block;
  }
}
@container (width >= 1183px) {
  :host([hide=xl]) {
    display: block;
  }
}
@container (width >= 2463px) {
  :host([hide=xxl]) {
    display: block;
  }
}
@media (width >= 320px) {
  :host([hide=xs]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 767px) {
  :host([hide=sm]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 927px) {
  :host([hide=md]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 928px) {
  :host([hide=lg]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 1183px) {
  :host([hide=xl]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 2463px) {
  :host([hide=xxl]:not(.in-container)) {
    display: block;
  }
}
:host([hide=always]) {
  display: none;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  flex-grow: 1;
  min-block-size: 0;
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbGF5b3V0LWZsZXgiLCJzb3VyY2VzIjpbImlkcy1sYXlvdXQtZmxleC1pdGVtLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFPRTtBQUFBO0VBRUUsWUFMYzs7O0FBR2hCO0FBQUE7RUFFRSxZQUxjOzs7QUFHaEI7QUFBQTtFQUVFLFlBTGM7OztBQUdoQjtBQUFBO0VBRUUsWUFMYzs7O0FBR2hCO0FBQUE7RUFFRSxZQUxjOzs7QUFHaEI7QUFBQTtFQUVFLFlBTGM7OztBQWFoQjtBQUFBO0VBRUUsV0FMYTs7O0FBR2Y7QUFBQTtFQUVFLFdBTGE7OztBQVNqQjtFQUNFOzs7QUFPQTtBQUFBO0VBRUUsYUFMZTs7O0FBR2pCO0FBQUE7RUFFRSxhQUxlOzs7QUFhakI7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBYVY7QUFBQTtFQUVFLFVBTFk7OztBQUdkO0FBQUE7RUFFRSxVQUxZOzs7QUFHZDtBQUFBO0VBRUUsVUFMWTs7O0FBR2Q7QUFBQTtFQUVFLFVBTFk7OztBQVdoQjtBQUFBO0VBRUU7OztBQUdGO0VBQ0U7OztBQUtGO0VBQ0U7OztBQUlGO0VBQTBDO0lBQXFCOzs7QUFFL0Q7RUFBMEM7SUFBcUI7OztBQUUvRDtFQUEwQztJQUFxQjs7O0FBRS9EO0VBQTBDO0lBQXFCOzs7QUFFL0Q7RUFBMEM7SUFBcUI7OztBQUUvRDtFQUEyQztJQUFzQjs7O0FBR2pFO0VBQW1DO0lBQXdDOzs7QUFFM0U7RUFBbUM7SUFBd0M7OztBQUUzRTtFQUFtQztJQUF3Qzs7O0FBRTNFO0VBQW1DO0lBQXdDOzs7QUFFM0U7RUFBbUM7SUFBd0M7OztBQUUzRTtFQUFvQztJQUF5Qzs7O0FBRTdFO0VBQ0U7OztBQUlGO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIExheW91dCBGbGV4IEl0ZW0gQ29tcG9uZW50ICovXG5AdXNlICcuLi8uLi90aGVtZXMvbWl4aW5zL2lkcy1jb3JlLW1peGlucycgYXMgKjtcblxuLy8gQWxpZ24tc2VsZlxuJGFsaWduLXNlbGYtbGlzdDogYXV0byBiYXNlbGluZSBjZW50ZXIgc3RyZXRjaCBmbGV4LXN0YXJ0IGZsZXgtZW5kO1xuXG5AZWFjaCAkYWxpZ24tc2VsZiBpbiAkYWxpZ24tc2VsZi1saXN0IHtcbiAgOmhvc3QoW2FsaWduLXNlbGY9JyN7JGFsaWduLXNlbGZ9J10pLFxuICAuaWRzLWxheW91dC1mbGV4LWl0ZW0tYWxpZ24tc2VsZi0jeyRhbGlnbi1zZWxmfSB7XG4gICAgYWxpZ24tc2VsZjogJGFsaWduLXNlbGY7XG4gIH1cbn1cblxuLy8gRmxleC1ncm93XG4kZmxleC1ncm93LWxpc3Q6IDAgMTtcblxuQGVhY2ggJGZsZXgtZ3JvdyBpbiAkZmxleC1ncm93LWxpc3Qge1xuICA6aG9zdChbZ3Jvdz0nI3skZmxleC1ncm93fSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1pdGVtLWdyb3ctI3skZmxleC1ncm93fSB7XG4gICAgZmxleC1ncm93OiAkZmxleC1ncm93O1xuICB9XG59XG5cbjpob3N0KFtncm93PScxJ10pIHtcbiAgbWluLWhlaWdodDogMDtcbn1cblxuLy8gRmxleC1zaHJpbmtcbiRmbGV4LXNocmluay1saXN0OiAwIDE7XG5cbkBlYWNoICRmbGV4LXNocmluayBpbiAkZmxleC1zaHJpbmstbGlzdCB7XG4gIDpob3N0KFtzaHJpbms9JyN7JGZsZXgtc2hyaW5rfSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1pdGVtLXNocmluay0jeyRmbGV4LXNocmlua30ge1xuICAgIGZsZXgtc2hyaW5rOiAkZmxleC1zaHJpbms7XG4gIH1cbn1cblxuLy8gRmxleFxuJGZsZXgtbGlzdDogMSAyIDMgNCA1IDYgNyA4IDkgMTAgMTEgMTIgMTMgMTQgMTUgMTYgMTcgMTggMTkgMjAgMjEgMjIgMjMgMjQ7XG5cbkBlYWNoICRmbGV4IGluICRmbGV4LWxpc3Qge1xuICA6aG9zdChbZmxleD0nI3skZmxleH0nXSksXG4gIC5pZHMtbGF5b3V0LWZsZXgtaXRlbS1mbGV4LSN7JGZsZXh9IHtcbiAgICBmbGV4OiAkZmxleDtcbiAgfVxufVxuXG4vLyBPdmVyZmxvd1xuJG92ZXJmbG93LWxpc3Q6IGF1dG8gaGlkZGVuIHZpc2libGUgc2Nyb2xsO1xuXG5AZWFjaCAkb3ZlcmZsb3cgaW4gJG92ZXJmbG93LWxpc3Qge1xuICA6aG9zdChbb3ZlcmZsb3c9JyN7JG92ZXJmbG93fSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1pdGVtLW92ZXJmbG93LSN7JG92ZXJmbG93fSB7XG4gICAgb3ZlcmZsb3c6ICRvdmVyZmxvdztcbiAgfVxufVxuXG4vLyBncm93L3Nocmluaz0wIG92ZXJyaWRlIC0gY2xhc3MtYmFzZWQgd29ya2Fyb3VuZCBmb3IgY29udGFpbmVyIGdyaWQgY29sbGFwc2Vcbi8vIE5vdGU6IDpoYXMoOjpzbG90dGVkKCkpIGlzIGludmFsaWQgQ1NTIGR1ZSB0byBTaGFkb3cgRE9NIHNwZWMgbGltaXRhdGlvbnNcbjpob3N0KC5oYXMtY29udGFpbmVyLWdyaWRbZ3Jvdz0nMCddW3Nocmluaz0nMCddKSxcbi5pZHMtbGF5b3V0LWZsZXgtaXRlbS5oYXMtY29udGFpbmVyLWdyaWQuaWRzLWxheW91dC1mbGV4LWl0ZW0tZ3Jvdy0wLmlkcy1sYXlvdXQtZmxleC1pdGVtLXNocmluay0wIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbjo6c2xvdHRlZChpZHMtaW5wdXRbc2l6ZT1cImZ1bGxcIl0pIHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xufVxuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIEhpZGUgYXQgYnJlYWtwb2ludFxuOmhvc3QoW2hpZGVdKSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbi8vIGBpZHMtc3BsaXR0ZXItcGFuZVtjb250YWluZXItcXVlcmllc11gKVxuQGNvbnRhaW5lciAod2lkdGggPj0gI3skYnJlYWtwb2ludC14c30pIHsgOmhvc3QoW2hpZGU9J3hzJ10pIHsgZGlzcGxheTogYmxvY2s7IH0gfVxuXG5AY29udGFpbmVyICh3aWR0aCA+PSAjeyRicmVha3BvaW50LXNtfSkgeyA6aG9zdChbaGlkZT0nc20nXSkgeyBkaXNwbGF5OiBibG9jazsgfSB9XG5cbkBjb250YWluZXIgKHdpZHRoID49ICN7JGJyZWFrcG9pbnQtbWR9KSB7IDpob3N0KFtoaWRlPSdtZCddKSB7IGRpc3BsYXk6IGJsb2NrOyB9IH1cblxuQGNvbnRhaW5lciAod2lkdGggPj0gI3skYnJlYWtwb2ludC1sZ30pIHsgOmhvc3QoW2hpZGU9J2xnJ10pIHsgZGlzcGxheTogYmxvY2s7IH0gfVxuXG5AY29udGFpbmVyICh3aWR0aCA+PSAjeyRicmVha3BvaW50LXhsfSkgeyA6aG9zdChbaGlkZT0neGwnXSkgeyBkaXNwbGF5OiBibG9jazsgfSB9XG5cbkBjb250YWluZXIgKHdpZHRoID49ICN7JGJyZWFrcG9pbnQteHhsfSkgeyA6aG9zdChbaGlkZT0neHhsJ10pIHsgZGlzcGxheTogYmxvY2s7IH0gfVxuXG4vLyBWaWV3cG9ydCBmYWxsYmFjayDigJQgdXNlZCB3aGVuIG5vIGNvbnRhaW5lci1xdWVyeSBhbmNlc3RvciBleGlzdHMuXG5AbWVkaWEgKHdpZHRoID49ICRicmVha3BvaW50LXhzKSB7IDpob3N0KFtoaWRlPSd4cyddOm5vdCguaW4tY29udGFpbmVyKSkgeyBkaXNwbGF5OiBibG9jazsgfSB9XG5cbkBtZWRpYSAod2lkdGggPj0gJGJyZWFrcG9pbnQtc20pIHsgOmhvc3QoW2hpZGU9J3NtJ106bm90KC5pbi1jb250YWluZXIpKSB7IGRpc3BsYXk6IGJsb2NrOyB9IH1cblxuQG1lZGlhICh3aWR0aCA+PSAkYnJlYWtwb2ludC1tZCkgeyA6aG9zdChbaGlkZT0nbWQnXTpub3QoLmluLWNvbnRhaW5lcikpIHsgZGlzcGxheTogYmxvY2s7IH0gfVxuXG5AbWVkaWEgKHdpZHRoID49ICRicmVha3BvaW50LWxnKSB7IDpob3N0KFtoaWRlPSdsZyddOm5vdCguaW4tY29udGFpbmVyKSkgeyBkaXNwbGF5OiBibG9jazsgfSB9XG5cbkBtZWRpYSAod2lkdGggPj0gJGJyZWFrcG9pbnQteGwpIHsgOmhvc3QoW2hpZGU9J3hsJ106bm90KC5pbi1jb250YWluZXIpKSB7IGRpc3BsYXk6IGJsb2NrOyB9IH1cblxuQG1lZGlhICh3aWR0aCA+PSAkYnJlYWtwb2ludC14eGwpIHsgOmhvc3QoW2hpZGU9J3h4bCddOm5vdCguaW4tY29udGFpbmVyKSkgeyBkaXNwbGF5OiBibG9jazsgfSB9XG5cbjpob3N0KFtoaWRlPSdhbHdheXMnXSkge1xuICBkaXNwbGF5OiBub25lO1xufVxuXG4vLyBTdGlja3kgbGF5b3V0IC0gYXBwbGllZCBieSBpZHMtZGF0YS1ncmlkW3N0aWNreS1sYXlvdXRdIHRvIHByb3BhZ2F0ZSBibG9jay1zaXplIGNvbnN0cmFpbnRcbjpob3N0KC5pZHMtZGF0YS1ncmlkLXN0aWNreS1sYXlvdXQtYW5jZXN0b3IpIHtcbiAgZmxleC1ncm93OiAxO1xuICBtaW4tYmxvY2stc2l6ZTogMDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbn1cbiJdfQ== */`;
